import { TimerDescription } from './TimerDescription';
import { TimerIndicator } from './TimerIndicator';
import { TimerRoot } from './TimerRoot';

export const Timer = Object.freeze({
  Root: TimerRoot,
  Indicator: TimerIndicator,
  Description: TimerDescription,
});
